/* eslint-disable max-len */
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {useIsWeb} from '../../../styles';

import ComicButton from '../ComicButton';

const ComicsTutorial = ({visible, onDismiss}) => {
    const {t} = useTranslation();
    const [step, setStep] = React.useState(1);
    const isWeb = useIsWeb();

    useEffect(() => {
        if (visible) {
            setStep(1);
        }
    }, [isWeb, visible]);

    const _nextStep = () => {
        if (step === 1 && !isWeb) {
            setStep(2);
        } else {
            setStep(3);
            onDismiss();
        }
    };

    const skip = () => {
        setStep(3);
        onDismiss();
    };

    if (step === 3 || !visible) {
        return null;
    }

    const mobileContent = (
        <Content>
            {step === 2 && (
                <>
                    <SwipeImage
                        src={require('../../../assets/ic_tutorial_swipe_up.png')}
                    />
                    <InvertedImage />
                </>
            )}

            <BallonHolder>
                <img
                    src={require('../../../assets/bg_tutorial_ballon.png')}
                    alt=""
                />
                <TutorialText>
                    {t(step === 1 ? 'comics.tutorial1' : 'comics.tutorial2')}
                </TutorialText>
                <ButtonNext onClick={_nextStep}>
                    <TextButton>
                        {step === 1 ? t('comics.next') : 'OK'}
                    </TextButton>
                </ButtonNext>
            </BallonHolder>
            {step === 1 && (
                <>
                    <ArrowImage />
                    <SwipeImage
                        src={require('../../../assets/ic_tutorial_swipe_down.png')}
                    />
                </>
            )}
        </Content>
    );

    const webContent = (
        <>
            <WebBottomBallon t={t} />
            <WebTopBallon t={t} />
        </>
    );

    return (
        <Container>
            {isWeb ? webContent : mobileContent}
            <NextButton
                onClick={skip}
                title={
                    isWeb ? t('comics.tutorialClose') : t('comics.tutorialSkip')
                }
            />
        </Container>
    );
};

const Container = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.5);
    flex-direction: column;
`;

const Content = styled.span`
    align-self: center;
    align-items: center;
    flex-direction: column;
    display: flex;
`;

const ArrowImage = styled.img.attrs({
    src: require('../../../assets/bg_tutorial_ballon_arrow.png'),
})`
    margin-left: 40px;
`;

const InvertedImage = styled(ArrowImage)`
    transform: scaleY(-1);
`;

const SwipeImage = styled.img`
    margin-left: 140px;
    margin-vertical: 18px;
`;

const TextButton = styled.span`
    font-family: AvenirNextRoundedStd;
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
    text-align: center;
    color: #000000;
    text-transform: uppercase;
`;

const BallonHolder = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
`;

const TutorialText = styled.span`
    font-family: AvenirNextRoundedStd;
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    text-align: center;
    text-transform: uppercase;
    color: #000000;
    margin-top: ${props => (props.marginTop ? props.marginTop : 22)}px;
    position: absolute;
    top: 0px;
    width: 200px;
    align-self: center;
`;

const ButtonNext = styled.span`
    position: absolute;
    bottom: 10px;
    right: 20px;
`;

const NextButton = styled(ComicButton)`
    position: absolute;
    bottom: 24px;
`;

const WebTopBallon = ({t}) => {
    return (
        <TopBallon>
            <InvertedImageH />
            <BallonHolder>
                <InvertedBallon
                    src={require('../../../assets/bg_tutorial_ballon.png')}
                    alt=""
                />
                <TutorialText marginTop={50}>
                    {t('comics.tutorial3')}
                </TutorialText>
            </BallonHolder>
        </TopBallon>
    );
};

const WebBottomBallon = ({t}) => {
    return (
        <BottomBallon>
            <BallonHolder>
                <img
                    src={require('../../../assets/bg_tutorial_ballon.png')}
                    alt=""
                />
                <TutorialText marginTop={50}>
                    {t('comics.tutorial4')}
                </TutorialText>
            </BallonHolder>
            <ArrowImage />
        </BottomBallon>
    );
};

const TopBallon = styled.div`
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
    position: absolute;
    top: 200px;
    left: calc(50% + 5px);
`;

const InvertedImageH = styled(InvertedImage)`
    transform: scale(1, -1);
`;

const InvertedBallon = styled.img`
    transform: scaleY(-1);
`;

const BottomBallon = styled.div`
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
    position: absolute;
    bottom: 90px;
    right: 4px;
`;

export default ComicsTutorial;
